module.exports = __webpack_public_path__ + "staticcomp/img/top.f40a369.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/2/top.jpg
// module id = 86sD
// module chunks = 39